export const fbConfig = {
    apiKey: "AIzaSyAo4TL2A_IYKBLEujycetlIHvWUX9EDr3g",
    authDomain: "gpi-x-4e1a5.firebaseapp.com",
    databaseURL: "https://gpi-x-4e1a5.firebaseio.com",
    projectId: "gpi-x-4e1a5",
    storageBucket: "gpi-x-4e1a5.appspot.com",
    messagingSenderId: "434986097050",
    appId: "1:434986097050:web:808f61c40a4127d0dc8223"
};
export const fbConfigStaging = {
    apiKey: 'AIzaSyC4uBTz2YhsKVbFBIjolraKeS2-HxsnhP0',
    authDomain: 'bwscart.firebaseapp.com',
    databaseURL: 'https://bwscart.firebaseio.com',
    projectId: 'bwscart',
    storageBucket: 'bwscart.appspot.com',
    appId: 'bwscart',
};
export const fbConfigDev = {
    "apiKey": "AIzaSyDBeCp2UPwu6cFhkeyFrXzRTExhQ1Ci4Po",
    "authDomain": "gpi-x-4e1a5.firebaseapp.com",
    "databaseURL": "https://gpi-x-4e1a5.firebaseio.com",
    "projectId": "gpi-x-4e1a5",
    "storageBucket": "gpi-x-4e1a5.appspot.com",
    "messagingSenderId": "434986097050",
    "appId": "gpi-x-4e1a5"
};
